import React, { PropTypes } from 'react';
import validators from '../../../common/validators';

class Form extends React.Component {

  static childContextTypes = {
    subscribe: PropTypes.func.isRequired,
    unsubscribe: PropTypes.func.isRequired,
    validate: PropTypes.func.isRequired,
    errors: PropTypes.objectOf(PropTypes.any)
  };

  constructor(props) {
    super(props);
    this.state = {
      errors: {}
    }
    this.components = {}


    this.handleSubmit = this.handleSubmit.bind(this)
    this.subscribe = this.subscribe.bind(this)
    this.unsubscribe = this.unsubscribe.bind(this)
    this.validateOne = this.validateOne.bind(this)
    this.validate = this.validate.bind(this)
    this.isValid = this.isValid.bind(this)
  }

  getChildContext() {
    return {
      subscribe: this.subscribe,
      unsubscribe: this.unsubscribe,
      validate: this.validateOne,
      errors: this.state.errors
    }
  }

  subscribe(component) {
    this.components[component.props.name] = component
  }

  unsubscribe(component) {
    const { errors } = this.state
    delete this.components[component.props.name]
    delete errors[component.props.name]

    this.setState({ errors })
  }

  validate() {
    const errors = {}
    for(let name in this.components) {
      if (this.components.hasOwnProperty(name)) {
        this.validateOne(name, errors)
      }
    }
    this.setState({ errors })
    return errors
  }

  isValid() {
    return !Object.keys(this.validate()).length
  }

  validateOne(name, _errors, shouldUpdate=true) {
    const errors = _errors || this.state.errors
    const component = this.components[name]
    errors[name] = null

    component.props.validate.every(rule => {
      if (!validators[rule]) {
        console.warn(`Form: Invalid rule '${rule}'`)
      } else if(!validators[rule].rule(component.value, this.components)) {
        if (shouldUpdate) {
          component.invalidate(validators[rule].hint(component.value, this.components))
        }
        errors[name] = rule
        return false
      }
      return true
    })

    if (shouldUpdate && !errors[name] && !component.state.isValid) {
      component.setState({
        isValid: true,
        hint: null
      })
    }

    if (!_errors) {
      this.setState({ errors })
    }
  }

  handleSubmit(e) {
    if (!this.isValid()) {
      e.preventDefault()
    }

    if (this.props.onSubmit) {
      this.props.onSubmit(e)
    }
  }

  render() {
    const { children, ...props } = this.props
    return (
      <form onSubmit={this.handleSubmit} {...props}>
        { children }
      </form>
    );
  }
}

export default Form;



/** WEBPACK FOOTER **
 ** ./src/components/base/Form/Form.js
 **/